export const DETAILS_TYPES = {
  LIMITATION: 'limitation',
  USAGE: 'usage',
  BALANCE: 'balance',
  GROSS: 'gross',
  NETT: 'nett',
  GUEST: 'guest',
};
